import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { Fragment } from 'react';
import { FormattedMessage as IntlFormattedMessage } from 'react-intl';

var FormattedMessage = function FormattedMessage(_ref) {
  var variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, ["variant"]);

  if (variant) {
    var Tag = variant || Fragment;
    return React.createElement(Tag, null, React.createElement(IntlFormattedMessage, rest));
  } // @ts-ignore


  return React.createElement(IntlFormattedMessage, _extends({}, rest, {
    "data-qa": "formatted-message"
  }));
};

export default FormattedMessage;